import Box from '@mui/material/Box';
import { Link } from "infrastructure/router";
import type { StepLabelProps } from './types';

const StepLabel = ({
    children,
    Icon,
    endAdornment,
    ...restProps
}: StepLabelProps) => (
    <Box
        {...restProps}
        component={Link}
        sx={{
            display: 'grid',
            gridTemplateColumns: 'auto 1fr auto',
            alignItems: 'center',
            gap: 1,
            textDecoration: 'none',
            whiteSpace: 'nowrap',
            color: theme => theme.palette.text.primary,
            ...restProps.sx
        }}
    >
        <Icon />
        <Box>
            {children}
        </Box>
        {endAdornment}
    </Box>
);

export default StepLabel;
